export const getProjectTitle = (
    code: string,
    name: string | null | undefined,
    purpose?: string,
): string => {
    const description = name ?? purpose
    return description ? `${code} | ${description}` : code
}
